import { AdvancedSearchController } from './advanced-search.controller'

function advancedSearch () {
  return {
    restrict: 'E',
    scope: {
      filters: '=',
      placeholder: '@',
      hasFilters: '<',
      hasAdvancedSearch: '<',
      value: '<',
      onSearch: '<',
      onFilter: '<',
      onCount: '<',
      onAssetClick: '<'
    },
    templateUrl: '/core/directives/advanced-search/advanced-search.html?$$REVISION$$',
    controller: AdvancedSearchController
  }
}
export { advancedSearch }
